import { RouterProvider } from "react-router-dom";
import { getRouter } from './router';
import React, { Suspense } from 'react'
import { useSelector } from 'react-redux';
import SiteLoader from './pages/components/SiteLoader';
import { ThemeProvider } from "@mui/material";
import { muiTheme } from "./theme";
import { APP_ENV } from "constants";
import BetaBanner from "pages/components/BetaBanner";


function App() {
	const user = useSelector(s => s.auth.data);

	return (
		<ThemeProvider theme={muiTheme}>
			<Suspense fallback={<SiteLoader />}>
				{
					APP_ENV === 'beta' && <BetaBanner />
				}
				<RouterProvider router={getRouter(user)} />
			</Suspense>
		</ThemeProvider>
	)
}

export default App;
